/**
 * MediaPipe FaceMesh wasm/loader asset locator.
 *
 * Default: jsDelivr CDN (nginx CSP must allow https://cdn.jsdelivr.net and
 * script-src 'wasm-unsafe-eval'). Restored to the pre-regression CDN form that
 * worked for Enterprise face-identity / salon capture.
 *
 * Optional same-origin: set REACT_APP_MEDIAPIPE_LOCAL=1 and ensure
 * public/vendor/mediapipe is copied into the production build (npm run build).
 */
const CDN_FACE_MESH = 'https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh';

export function locateFaceMeshAsset(file) {
  if (process.env.REACT_APP_MEDIAPIPE_LOCAL === '1') {
    const base = `${process.env.PUBLIC_URL || ''}/vendor/mediapipe/face_mesh`.replace(/\/$/, '');
    return `${base}/${file}`;
  }
  return `${CDN_FACE_MESH}/${file}`;
}
